import { Post } from '@/model/data-object/Post'
import useConfiguration from '@/composables/configuration/configuration'

const ANALYTICS_EVENT_NAME = 'anzu.forum.metric'

export const ANALYTICS_EVENT_POST_NEW = 'post-new'
export const ANALYTICS_EVENT_POST_RESPOND = 'post-respond'
export const ANALYTICS_EVENT_POST_SUBSCRIBE = 'post-subscribe'
export const ANALYTICS_EVENT_POST_USER_SUBSCRIBE = 'post-user-subscribe'
export const ANALYTICS_EVENT_POST_COPY_LINK = 'post-show-copy-link'
export const ANALYTICS_EVENT_POST_SHARE_FACEBOOK = 'post-share-facebook'
export const ANALYTICS_EVENT_POST_SHARE_MESSENGER = 'post-share-messenger'
export const ANALYTICS_EVENT_POST_SHARE_VIBER = 'post-share-viber'
export const ANALYTICS_EVENT_POST_SHARE_WHATS_APP = 'post-share-whats-app'
export const ANALYTICS_EVENT_POST_SHARE_LINKED_IN = 'post-share-linked-in'
export const ANALYTICS_EVENT_POST_SHARE_LINK = 'post-share-link'
export const ANALYTICS_EVENT_POST_VOTE_LIKE = 'post-like'
export const ANALYTICS_EVENT_POST_VOTE_SUPER_LIKE = 'post-super-like'
export const ANALYTICS_EVENT_POST_VOTE_SUPER_LIKE_CONFIRMATION =
  'post-super-like-confirmation'
export const ANALYTICS_EVENT_POST_VOTE_DISLIKE = 'post-dislike'
export const ANALYTICS_EVENT_POST_REPORT = 'post-report'
export const ANALYTICS_EVENT_POST_REPORT_CONFIRMATION =
  'post-report-confirmation'
export const ANALYTICS_EVENT_POST_EDIT_OPEN = 'post-edit-open'
export const ANALYTICS_EVENT_POST_EDIT_SAVE = 'post-edit-save'

export const ANALYTICS_SYSTEM_NAME = 'forum'

export default function useAnalyticsManager() {
  const propagateAnalyticsEvent = (post: Post, eventName: string): void => {
    const { configuration } = useConfiguration()
    if (configuration.widget.analyticsEventDisabled) {
      return
    }
    const event = new CustomEvent(ANALYTICS_EVENT_NAME, {
      detail: {
        eventName: eventName,
        data: {
          event: ANALYTICS_SYSTEM_NAME,
          forumPost: eventName,
          topicId: post.topic.id,
          postId: post.id,
          articleId: post.topic.extId,
        },
      },
    })
    window.dispatchEvent(event)
  }

  return {
    propagateAnalyticsEvent,
  }
}
